import { useState } from 'react'
import {
  Box,
  Button,
  Divider,
  Paper,
  TextField,
  Typography,
} from '@mui/material'
import logo from '../../logo.png'
import {
  ResourceInfoFormValues,
  ResourceInfoSection,
} from './resourceInfoSection'
import { ReferralVerificationData } from './types'

export interface ReferralResourceUpdateFormProps {
  referral: ReferralVerificationData
  trackingRef: string
  onSubmit: (values: {
    resource: ResourceInfoFormValues
    remarks: string
  }) => void
}

export const ReferralResourceUpdateForm = ({
  referral,
  trackingRef,
  onSubmit,
}: ReferralResourceUpdateFormProps): JSX.Element => {
  const [resourceValues, setResourceValues] = useState<ResourceInfoFormValues>()
  const [remarks, setRemarks] = useState('')

  const handleSubmit = (): void => {
    if (!resourceValues) return
    onSubmit({ resource: resourceValues, remarks })
  }

  return (
    <Box>
      <Box
        display="flex"
        flexDirection={{ xs: 'column', sm: 'row' }}
        justifyContent="space-between"
        alignItems="flex-start"
        mb={2}
        gap={2}
      >
        <Box>
          <Typography variant="h6" color="primary.main" fontWeight={600}>
            Update Resource Information
          </Typography>
          <Typography variant="body1" color="text.disabled">
            You are suggesting an update to the resource details for{' '}
            <Box component="span" color="text.primary" fontWeight={700}>
              {referral.center?.name || 'this resource'}
            </Box>
            .
          </Typography>
        </Box>
        <Box
          component="img"
          src={logo}
          alt="resolvexLogo"
          sx={{ width: { xs: 64, sm: 96 } }}
        />
      </Box>

      <Paper sx={{ p: { xs: 1.5, sm: 2 } }}>
        <Typography variant="caption" color="text.secondary">
          Tracking Ref: {trackingRef}
        </Typography>
        <Divider sx={{ my: 2 }} />

        {referral.center && (
          <ResourceInfoSection
            center={referral.center}
            onChange={setResourceValues}
          />
        )}
        <Divider sx={{ my: 2 }} />

        <TextField
          fullWidth
          multiline
          rows={4}
          label="Remarks / Notes"
          value={remarks}
          onChange={(e) => setRemarks(e.target.value)}
          sx={{ mb: 2 }}
        />
        <Button variant="contained" size="large" onClick={handleSubmit}>
          Update Resource Information
        </Button>
      </Paper>
    </Box>
  )
}
